<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      @closed="handleClose"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <div slot="title" class="dialog-title">
        <span>{{ title }}收货地址</span>
      </div>
      <div class="dialog-form">
        <el-form
          ref="form"
          :model="form"
          label-position="left"
          label-width="100px"
          :rules="rules"
        >
          <!-- <el-form-item label="单位" prop="untName">
            <el-select
              style="width: 100%"
              v-model="form.untName"
              placeholder="请选择单位"
            >
              <el-option
                v-for="item in untNameOp"
                :key="item.id"
                :label="item.unitName"
                :value="item.unitCrmId"
              >
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item label="地区" prop="crityz">
            <city
              ref="cityy"
              :rule="false"
              :subcirt-arry="subcirtArry"
              @submitt="submitt"
              @changeClear="changeClear"
            />
            <el-input
              v-model="form.crityz"
              style="display: none; width: 10px; height: 10px"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="详细地址" prop="addresslu">
            <div class="addressPhone">
              <div style="display: flex; align-items: center">
                <el-input
                  v-model="form.addresslu"
                  placeholder="请输入路"
                ></el-input>

                <div class="lu">路/街/道/弄</div>
              </div>
              <div style="display: flex; align-items: center">
                <el-input
                  v-model="form.addresshao"
                  placeholder="请输入号"
                ></el-input>
                <div style="margin: 0 20px">号</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label=" ">
            <el-input
              v-model="form.addinfor"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>

          <el-form-item label="默认地址" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio key="1" label="是"
                ><span style="color: #606266 !important">是</span></el-radio
              >
              <el-radio key="2" label="否"
                ><span style="color: #606266 !important">否</span></el-radio
              >
            </el-radio-group>
          </el-form-item>

          <div class="dialog-btns">
            <el-button class="cancel butttenhober" @click="cancellation"
              >取消</el-button
            >
            <el-button class="confirm" @click="addAddress('form')"
              >提交</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userApi from "@/api/user.js";
import { mapGetters } from "vuex";
import city from "@/views/user/components/city.vue";
export default {
  name: "MouseOrder",
  components: {
    city,
  },
  data() {
    var validateadd = (rule, value, callback) => {
      if (this.form.addresslu && this.form.addresshao) {
        callback();
      } else {
        if (this.form.addresslu) {
          callback(new Error("请输入号"));
        } else {
          callback(new Error("请输入路/街/道/弄"));
        }
      }
    };
    const reg = /^[\u4e00-\u9fa5]$/;
    var validatePass = (rule, value, callback) => {
      let len = 0;
      for (let i = 0; i < value.length; i++) {
        let word = value.charAt(i); //获取指定位置的字符
        if (!reg.test(word)) {
          //再用正则判断这个字符是否是中文
          //非中文单字节加1
          len++;
        } else {
          //中文单字节加5
          len++;
          // len += 5
        }
      }
      if ((len < 1 && len > 0) || len > 5) {
        // callback(new Error('姓名长度为1-25个字符，一个中文字等于5个字符'))
        callback(new Error("姓名长度为1-5个汉字"));
      } else {
        callback();
      }
    };
    return {
      // untNameOp: [],
      // 点编辑三级联动区域
      subcirtArry: {},
      cirtArry: [],
      // 最后选择的三级联动区域
      dialogVisible: false,
      title: "新增",
      edit: false,
      form: {
        untName: "",
        phone: "",
        name: "",
        cirtArry: "",
        addinfor: "",
        type: "",
        crityz: "",
        addresslu: "",
        addresshao: "",
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入手机号码",
          },
          // 手机号格式
          {
            required: true,
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
        // untName: [
        //   {
        //     required: true,
        //     message: "请选择单位",
        //   },
        // ],
        name: [
          {
            required: true,
            message: "请输入姓名",
          },
          { validator: validatePass },
        ],
        cirtArry: [
          {
            required: true,
            message: "请选择地区",
          },
        ],
        addresslu: [
          // {
          //   required: true,
          //   message: "请输入详细地址",
          // },
          { required: true, validator: validateadd },
        ],
        crityz: [
          {
            required: true,
            message: "请选择地址",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择是否选中默认地址",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
    }),
  },
  mounted() {
    // this.getUntiNmae();
  },
  methods: {
    cancellation() {
      this.form = {
        // untName: "",
        phone: "",
        name: "",
        cirtArry: [],
        addinfor: "",
        type: "",
        crityz: "",
        addresslu: "",
        addresshao: "",
      };
      this.dialogVisible = false;
      this.$refs["form"].resetFields();
    },
    // getUntiNmae() {
    //   this.options = [];
    //   let params = {
    //     channel: "pc",
    //     type: 3,
    //     customerId: this.userInfo.customerId,
    //   };

    //   userApi.unitList(params).then((res) => {
    //     this.untNameOp = res.data;
    //   });
    // },
    startCounter() {
      this.counter = 60;
      this.interval = setInterval(() => {
        this.counter--;
        if (this.counter <= 0) {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    submitt(submitt) {
      this.form.cirtArry = submitt;
      this.form.crityz = submitt[0].Code;
      return new Promise((resolve) => {
        if (submitt.length > 0) {
          resolve(1);
        } else {
          resolve(0);
        }
      });
    },
    handleClose() {
      this.form = {
        // untName: "",
        phone: "",
        name: "",
        cirtArry: [],
        addinfor: "",
        type: "",
        crityz: "",
        addresslu: "",
        addresshao: "",
      };
      this.dialogVisible = false;
      this.$refs["form"].resetFields();
    },
    changeClear() {
      this.form.crityz = "";
    },
    isShow() {
      this.dialogVisible = true;
      this.title = "新增";
      this.edit = false;
    },
    findAddress(item, index) {
      this.title = "修改";
      this.edit = true;
      this.dialogVisible = true;

      this.form.addinfor = item.detailAddress;
      this.form.addresslu = item.road || "";
      this.form.addresshao = item.number || "";

      userApi.findAdress(item.id).then((res) => {
        this.dleItem = item;
        this.form.name = res.data.name;
        // this.form.untName = res.data.unitCrmId;
        this.form.phone = res.data.mobile;

        this.form.type = res.data.isDefault ? "是" : "否";
        console.log(res.data);
        let params = {
          cid: res.data.cityCode,
          city: res.data.cityName,
          economize: res.data.provinceName,
          economizeCode: res.data.provinceCode,
          distinguish: res.data.countyName,
          distinguishCode: res.data.countyCode,
          pid: res.data.provinceCode,
        };
        this.subcirtArry = params;
        this.$refs.cityy.sub(params);
        this.form.crityz = "1";
        this.$refs["form"].clearValidate();
      });
    },
    addAddress() {
      this.$refs.cityy.submit().then((res) => {
        this.submitForm("form");
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            id: 0,
            channel: "pc",
            cityCode: this.form.cirtArry[1].Code,
            cityName: this.form.cirtArry[1].Name,
            countyCode: this.form.cirtArry[2].Code,
            countyName: this.form.cirtArry[2].Name,
            // customerId: this.userInfo.customerId,
            detailAddress: this.form.addinfor,
            isDefault: this.form.type == "是" ? true : false,
            mobile: this.form.phone,
            name: this.form.name,
            provinceCode: this.form.cirtArry[0].Code,
            provinceName: this.form.cirtArry[0].Name,
            provinceId: this.form.cirtArry[4].provinceId,
            cityId: this.form.cirtArry[4].cityId,
            countyId: this.form.cirtArry[4].countyId,

            road: this.form.addresslu,
            number: this.form.addresshao,
            unitCrmId: "67871c681148ca0001f4ffb2",
          };
          if (this.edit) {
            params.id = this.dleItem.id;
          }
          console.log(params, "==params=");
          this.$loading.show();

          userApi.addAdress(params).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.dialogVisible = false;
              this.$forceUpdate();
              this.$emit("getadd");
              this.addOptions = [];
              this.$loading.hide();
              // this.getAdd();
            } else {
              this.$message.error(res.msg);
              this.$loading.hide();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.lu {
  margin: 0 20px;
  white-space: nowrap;
  @media (max-width: 1023px) {
    margin: 0 8px;
  }
}
.dialog {
  .dialog-title {
    text-align: left;
    font-size: 30px;
    color: #000;
    border-bottom: 4px solid #e5e5e5;
    width: calc(100% + 40px);
    margin-left: -20px;
    padding-bottom: 20px;
    padding-left: 60px;
    position: relative;

    span {
    }

    &::before {
      display: block;
      content: "";
      width: 65px;
      height: 4px;
      background-color: var(--ThemeColor);
      position: absolute;
      bottom: -4px;
      left: 60px;
    }
  }

  .dialog-form {
    padding: 0 60px;
    text-align: left;

    .get-verify {
      width: 100%;
      background-color: #3c4250;
      color: var(--textWhite);
    }

    .dilog-select {
      width: 100%;
    }

    .dialog-btns {
      text-align: center;

      .cancel,
      .confirm {
        font-size: 16px;
      }

      .confirm {
        color: var(--textWhite);
        background-color: var(--ThemeColor);
      }
    }

    /deep/.el-radio__input.is-checked .el-radio__inner {
      border-color: var(--ThemeColor);
      background: var(--ThemeColor);
    }
  }
}
.addressPhone {
  display: flex;
  // margin-bottom: 20px;
  @media (max-width: 1023px) {
    margin-top: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/addAddress.vue